import { defineMessage } from 'react-intl';

export const errorCommonI18n = {
  general: defineMessage({
    id: 'common:error.general',
    defaultMessage: 'An error has occurred. Please try again later.'
  }),
  generalAlternative: defineMessage({
    id: 'common:error.general-alt',
    defaultMessage: 'Something went wrong!'
  }),
  invalidCurrencyAmount: defineMessage({
    id: 'common:error.invalid-currency-amount',
    defaultMessage: 'Please enter a valid amount'
  }),
  invalidPrice: defineMessage({
    id: 'common:error.invalid-price',
    defaultMessage: 'Please enter a valid price'
  }),
  invalidDate: defineMessage({
    id: 'common:error.invalid-date',
    defaultMessage: 'Please enter a valid date'
  }),
  invalidEmail: defineMessage({
    id: 'common:error.invalid-email',
    defaultMessage: 'Please enter a valid email address'
  }),
  invalidEmailPassword: defineMessage({
    id: 'common:error.invalid-email-password',
    defaultMessage: 'Email and password are incorrect'
  }),
  invalidNumber: defineMessage({
    id: 'common:error.invalid-number',
    defaultMessage: 'Please enter a valid number'
  }),
  invalidPhoneNumber: defineMessage({
    id: 'common:error.invalid-phone-number',
    defaultMessage: 'Please enter a valid phone number'
  }),
  invalidTime: defineMessage({
    id: 'common:error.invalid-time',
    defaultMessage: 'Please enter a valid time'
  }),
  passwordOldInvalid: defineMessage({
    id: 'common:error.password.old-incorrect',
    defaultMessage: 'Your old password is incorrect'
  }),
  passwordRepeatingChar: defineMessage({
    id: 'common:error.password.repeating-character',
    defaultMessage:
      'Your password is not strong enough. Avoid repeating sequences of characters or numbers.'
  }),
  passwordRepeatMismatch: defineMessage({
    id: 'common:error.password.repeat-mismatch',
    description: 'Error message when repeated password is incorrect',
    defaultMessage: 'Passwords do not match'
  }),
  passwordTooLong: defineMessage({
    id: 'common:error.password.too-long',
    defaultMessage:
      'Your password has too many characters. Your password must have 128 characters or fewer.'
  }),
  passwordTooShort: defineMessage({
    id: 'common:error.password.too-short',
    defaultMessage:
      'Your password is not strong enough. Your password must be at least 8 characters.'
  }),
  priceMinAmount: defineMessage({
    id: 'common:error.price.min-amount',
    defaultMessage: 'Price must be at least {amount}'
  }),
  priceMaxAmount: defineMessage({
    id: 'common:error.price.max-amount',
    defaultMessage: 'Price must not exceed {amount}'
  }),
  required: defineMessage({
    id: 'common:error.required',
    defaultMessage: 'Field is required'
  }),

  '404Page': {
    code: defineMessage({
      id: 'common:error.404-page.code',
      defaultMessage: '404 error'
    }),
    heading: defineMessage({
      id: 'common:error.404-page.heading',
      defaultMessage: 'Page not found'
    }),
    description: defineMessage({
      id: 'common:error.404-page.description',
      defaultMessage: "Sorry, we couldn't find the page you're looking for"
    })
  },

  '500Page': {
    code: defineMessage({
      id: 'common:error.500-page.code',
      defaultMessage: '500 error'
    }),
    heading: defineMessage({
      id: 'common:error.500-page.heading',
      defaultMessage: 'Unexpected error'
    }),
    description: defineMessage({
      id: 'common:error.500-page.description',
      defaultMessage: 'Sorry, we are working on fixing the problem'
    })
  }
};
